import * as React from "react";
const SvgCrossIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#5BA6FD", strokeLinecap: "round", strokeWidth: 2, d: "M17 7 7 17m10 0L7 7" }));
export default SvgCrossIcon;
